import React from 'react'
import type { BaseWeatherIconProps } from '../WeatherIcon'

const WeatherIconDaySnowShower: React.FC<BaseWeatherIconProps> = ({
  className = '',
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 100 100"
      fill="none"
      className={className}
    >
      <path
        d="M62.3781 73.8715L58.6883 75.0653V71.188H55.7285V75.0653L52.0289 73.8715L51.1113 76.6833L54.811 77.8869L52.5221 81.0242L54.9195 82.7606L57.2084 79.6233L59.4874 82.7606L61.8848 81.0242L59.5959 77.8869L63.2956 76.6833L62.3781 73.8715Z"
        fill="#D2E0FF"
      />
      <path
        d="M46.5831 77.818L42.9031 79.0118V75.1345H39.9434V79.0118L36.2437 77.818L35.3262 80.6298L39.0259 81.8334L36.737 84.9708L39.1344 86.7071L41.4233 83.5698L43.6924 86.7071L46.0898 84.9708L43.8108 81.8334L47.5006 80.6298L46.5831 77.818Z"
        fill="#D2E0FF"
      />
      <path
        d="M79.0807 84.576L78.1632 81.7642L74.4733 82.958V79.0807H71.5136V82.958L67.8238 81.7642L66.9062 84.576L70.5961 85.7796L68.3171 88.9169L70.7145 90.6533L72.9935 87.516L75.2725 90.6632L77.6699 88.9169L75.3909 85.7796L79.0807 84.576Z"
        fill="#D2E0FF"
      />
      <path
        d="M37.0166 36.9953C38.5373 33.5812 41.032 30.722 44.0933 28.5494C42.0955 24.9566 38.1596 22.4736 33.5677 22.4736C26.978 22.4736 21.6406 27.5242 21.6406 33.7599C21.6406 37.2681 23.37 40.3624 26.0238 42.4315C28.7968 39.5159 32.6533 37.5126 37.0166 36.9953Z"
        fill="#F9D23E"
      />
      <path d="M35.779 10H31.6211V19.1474H35.779V10Z" fill="#F9D23E" />
      <path
        d="M18.2872 15.6885L15.7754 18.2L22.0539 24.4794L24.5657 21.968L18.2872 15.6885Z"
        fill="#F9D23E"
      />
      <path d="M19.1474 31.6211H10V35.779H19.1474V31.6211Z" fill="#F9D23E" />
      <path
        d="M49.2581 15.6884L42.9805 21.9678L45.4922 24.4788L51.7699 18.1994L49.2581 15.6884Z"
        fill="#F9D23E"
      />
      <path
        d="M24.8104 45.7374L22.1113 43.2632L14.9883 49.7926L17.833 52.4106L24.4968 46.3123L24.9672 45.8708L24.8104 45.7374Z"
        fill="#F9D23E"
      />
      <path
        d="M79.9835 49.6409H75.4699V45.2014C75.4699 35.4045 67.381 27.4633 57.4057 27.4633C52.7637 27.4633 48.5958 29.2291 45.4156 32.0624C42.8378 34.357 40.8921 37.3399 39.9934 40.7619H39.3514C35.5884 40.7619 32.181 42.2783 29.7316 44.7125C27.302 47.1268 25.8008 50.429 25.8008 54.0804C25.8008 61.4231 31.865 67.379 39.3415 67.379H43.8551H70.9464H79.9736C84.9613 67.379 89.0008 63.4084 89.0008 58.51C89.0106 53.6115 84.9711 49.6409 79.9835 49.6409Z"
        fill="#87D6F8"
      />
    </svg>
  )
}

export default WeatherIconDaySnowShower
